import { FOCUSABLE_SELECTORS } from 'src/components/common/items-navigator';

export * from './table';
export { SetFilter, setFilterDoesFilterPass } from './filters/set-filter';
export { RadioSetFilter, radioSetFilterDoesFilterPass } from './filters/radio-set-filter';
export { TableActiveFilters } from './active-filters';
export { ServerSideTable } from './server-side-table';
export {
  textWithFallback,
  DateCell,
  TranslatedCell,
  TagListCell,
  UserLinkCell,
  DeleteActionCell,
} from './cell-renderers';

/**
 * @link https://www.ag-grid.com/react-data-grid/keyboard-navigation/#example-cell-renderer-keyboard-navigation
 * @param {import('ag-grid-community').SuppressKeyboardEventParams} params
 * @returns {boolean} - true to suppress default behavior, false to allow
 */
export function cellActionKeyboardNavigate(params) {
  if (!params.event) return false;

  if (params.event.key === 'Tab') {
    const cell = params.event.target.closest('.ag-cell');
    const focusableElements = Array.from(
      cell?.querySelectorAll(FOCUSABLE_SELECTORS.join(',')) || [],
    );

    if (focusableElements.length === 0) return false;

    const currentIndex = focusableElements.indexOf(params.event.target);
    const isShift = params.event.shiftKey;
    const isFirst = currentIndex === 0;
    const isLast = currentIndex === focusableElements.length - 1;

    // Allow Tab to escape cell when at boundary
    if ((!isShift && isLast) || (isShift && isFirst)) {
      return false;
    }

    // Suppress to handle internal navigation within cell
    return true;
  }

  return ['Enter', 'Escape'].includes(params.event.key);
}

/**
 * @link https://www.ag-grid.com/react-data-grid/filtering/
 */
export const AG_FILTER_TYPES = Object.freeze({
  /**
   * Default text filter
   */
  TEXT: 'agTextColumnFilter',
  /**
   * Default number filter
   */
  NUMBER: 'agNumberColumnFilter',
  /**
   * Default date filter
   */
  DATE: 'agDateColumnFilter',
});

/**
 * Server-side filter pass function - always returns true
 * Used when filtering is done server-side and we don't need client-side filtering
 */
export const serverSideFilterDoesFilterPass = () => true;
